/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReportPackageNotes = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M7 10a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm4-2.83a3.001 3.001 0 1 0 3.941 2.236L11 11.763zm2 0v1.067l.914-.547A3.028 3.028 0 0 0 13 7.17zM6 16v2h12v-2z" />
        <path d="M2 2h20v20H2zm2 2v16h16V4z" />
      </g>
    </g>
  </Icon>
);
export { SvgReportPackageNotes as ReportPackageNotes };
